import { devicesApi } from "@/services/api.devices.service";
import { AreaContentConfiguration } from "@/types/area-tree/AreaContentConfiguration";
import { AreaTreeNodeType } from "@/types/area-tree/AreaTreeNodeType";

function createDeviceContentConfig(
	label: string,
	icon: string,
	nodeType: AreaTreeNodeType,
	deviceTypeId: number
): AreaContentConfiguration {
	return {
		idField: "deviceId",
		contentTitle: label,
		icon,
		nodeType,
		onLoad: async (groupId, regionUrl) => devicesApi.getDevicesForGroupTree(groupId, deviceTypeId, regionUrl),
		onSearch: async (query, regionUrl) =>
			devicesApi.searchDevicesForGroupTree(query, [deviceTypeId], false, regionUrl)
	};
}

const cameras = createDeviceContentConfig("Cameras", "fa-camera", AreaTreeNodeType.Camera, 1);
const doors = createDeviceContentConfig("Doors", "fa-door-open", AreaTreeNodeType.Door, 3);

export { cameras, doors };
